import {
  AccountRoleEnum,
  UserInfo,
  UserLanguageEnum,
  UserStatusEnum,
} from "@/entities/account/account.types"

export const DEFAULT_USER_FORM: UserInfo = {
  email: "",
  id: "",
  userName: "",
  createDt: "",
  nationality: "KR",
  role: AccountRoleEnum.User,
  userLanguage: UserLanguageEnum.Ko,
  status: UserStatusEnum.Verified,
}

export const DEFAULT_NUMBER_ARRAY = ["", "", "", "", "", ""]
